<template>
    <div style="min-height: 100%;">
        <div :id="editorId" style="width: 100%; min-height: 400px;">

        </div>
        <div>
            <h1>{{$t('inlineHelp')}}:</h1>
            <div v-if="documentationForActualWord != null">
                <h2>{{documentationForActualWord.name}}</h2>
                <div class="help-item" v-html="documentationForActualWord.description"></div>
            </div>
          <hr/>
          <pre>
const qr = (def) => {
      purge = () => void
      execute = () => SimplifiedEntities[]
      param = (name, type, operator, value, negation) => qr
      byId = (idVal) => SimplifiedEntity
    }
}

const createOperation = (def, securityGroup) => {
  setParam = (name, value) => createOperation
  save = () => void
  fromEntity = (entity) => createOperation
  get = () => operation
}

Content.{operationVariable};
Definitions.{code}
          </pre>
        </div>
    </div>
</template>





<script>
    import '../../ace-builds/src-noconflict/ace';
    import '../../ace-builds/src-noconflict/theme-clouds';
    import '../../ace-builds/src-noconflict/ext-language_tools'
    import '../../ace-builds/src-noconflict/mode-javascript';

    export default {
        name: "AceEditor",
        props: ['value'],
        data: function () {
            return {
                editor: {},
                internalValue: '',
                editorId: "id" + Math.round(Math.random() * 10),
                actualEditorWord: "",
                remoteDocumentation: {
                    AccountService: {
                        description: `Manages accounts and related objects`,
                        methods: {
                            createAccountBalance: {
                                name: `Create account balance`,
                                description: `
                                <pre>LocalDate balanceDate;
Long startBalance;
Long endBalance;
Map<String, Long> creditsByCurrency;
Map<String, Long> debitsByCurrency;
String accountId;</pre>`
                            }
                        }
                    },
                    NotificationService: {
                        description: `Sends notification to OpenTreasury UI`,
                        methods: {
                            notify: {
                                name: `Notify`,
                                description: `
                                    <pre>notify(caption, message, importance)</pre>
                                `
                            }
                        }
                    },
                    OperationService: {
                        description: `Contains all necessary methods for interacting with Operations`,
                        methods: {
                            createOperation: {
                                name: "Create operation",
                                description: `
                                    <pre>createOperation(definitionId, parameterValues, source)</pre>
                                    <ul>
                                        <li><b>definitionId</b> - ID of OperationDefinition to create</li>
                                        <li><b>parameterValues</b> - map of properties to be set in Operation</li>
                                        <li><b>source</b> - specification of source in operation (<i>Meta.Source</i> may be used)</li>
                                    </ul>
                                Creates operation</br>`
                            },
                            loadOperationDefinitions: {
                                name: "loadOperationDefinitions",
                                description: ""
                            },
                            getDefinitionByCode: {
                                name: "getDefinitionByCode",
                                description: ""
                            },
                            getOperation: {
                                name: "getOperation",
                                description: ""
                            },
                            deleteOperationsByQuery: {
                                name: "deleteOperationsByQuery",
                                description: ""
                            },
                            deleteOperationsBySource: {
                                name: "deleteOperationsBySource",
                                description: "Deletes operations with given source"
                            }
                        }
                    }
                }
            }
        },
        computed: {
            documentationForActualWord: function() {
                if(this.remoteDocumentation == null) return "";
                let values = Object.keys(this.remoteDocumentation).filter(v => v == this.actualEditorWord);
                if(values.length > 0) return { name: values[0], description: this.remoteDocumentation[values[0]].description };
                else { //todo: improve ... a lot
                    values = Object.keys(this.remoteDocumentation)
                        .map(v => Object.keys(this.remoteDocumentation[v].methods)
                            .filter(m => m == this.actualEditorWord)
                            .map(m =>
                                ({
                                    name: this.remoteDocumentation[v].methods[m].name,
                                    description: this.remoteDocumentation[v].methods[m].description
                                })
                            )
                        );

                    if(values[0].length > 0) return values[0][0];
                }

                return null;
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    let adjustedVal = '';
                    if(newVal !== undefined)
                        adjustedVal = newVal;


                    if(this.internalValue !== adjustedVal && this.editor != null)
                        this.editor.setValue(adjustedVal, 1)
                    this.internalValue = adjustedVal;

                }
            }
        },
        created() {

        },
        mounted() {
            const langTools = window.ace.require('ace/ext/language_tools')
            this.editor = window.ace.edit(this.editorId)
            this.editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: true,
            });

            this.editor.getSession().setMode(`ace/mode/javascript`)
            this.editor.setTheme(`ace/theme/clouds`)

            const actualWordSettingCallback = (e) => {
                let cursor = this.editor.getSelection().getCursor();
                let word = this.editor.getSession().getAWordRange(cursor.row, cursor.column);
                let text = this.editor.getSession().getDocument().getTextRange(word);
                this.actualEditorWord = text;
            };


            this.editor.getSelection().on("changeCursor", actualWordSettingCallback);

            const flowCompleter = {
                getCompletions: function(editor, session, pos, prefix, callback) {
                    let toReturn = [];
                    if(pos.column > 1) {
                        let token = session.getTokenAt(pos.row, pos.column - 1);
                        if(token.type === "identifier") {
                            if(this.remoteDocumentation[token.value] !== undefined) {
                                toReturn.push(... Object.keys(this.remoteDocumentation[token.value].methods).map(
                                    key => ({
                                        caption: key,
                                        value: key,
                                        score: 110,
                                        meta: "Method"
                                    })
                                )
                                    .filter(val => val.caption.startsWith(prefix)));
                            }
                        }

                    }
                    toReturn.push(... Object.keys(this.remoteDocumentation).map(
                        key => ({
                            caption: key,
                            value: key,
                            score: 100,
                            meta: "Service"
                        })
                    )
                        .filter(val => val.caption.startsWith(prefix)));
                    callback(null,
                        toReturn
                    )


                    /*[{
                    caption: "MappingService",
                    value: "mappingService",
                    score: 100,
                    meta: "CORE"
                  }]);*/
                }.bind(this)
            }
            langTools.setCompleters([flowCompleter]); //todo: change to addCompleter way

            this.editor.setValue(this.value, 1);
            this.editor.on('change', () => {
                this.internalValue = this.editor.getValue();
                this.$emit('input', this.internalValue)
            })
        }
    }
</script>

<style lang="scss" scoped>
    .help-item {
        border-left: 2px solid var(--accent-color-plus-75);
        padding-left: 10px;
    }
</style>
